import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { TargetAudience } from './components/TargetAudience';
import { Creator } from './components/Creator';
import { AccessDetails } from './components/AccessDetails';
import { Results } from './components/Results';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-[#0B1426] text-gray-100 font-sans selection:bg-blue-500/30" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <Hero data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Solution data-id="element-4" />
      <Modules data-id="element-5" />
      <Bonuses data-id="element-6" />
      <TargetAudience data-id="element-7" />
      <Creator data-id="element-8" />
      <AccessDetails data-id="element-9" />
      <Results data-id="element-10" />
      <Testimonials data-id="element-11" />
      <Pricing data-id="element-12" />
      <Guarantee data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}